import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { Drawer, Grid } from '@mui/material';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

export const DRAWER_WIDTH = 550;

type TitledDrawerProps = {
  title: string;
  titleChip?: React.ReactNode;
  open: boolean;
  onClose: (e?: any, reason?: any) => void;
  children: React.ReactNode;
  openAll?: any;
};
export default function TitledDrawer({ title, titleChip, open, onClose, children, openAll }: TitledDrawerProps) {
  const { t } = useTranslation();
  const handleClose = () => {
    onClose();
  };

  return (
    <div>
      <Drawer
        className="titled-drawer"
        disableRestoreFocus
        anchor="right"
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            display: 'flex',
            flexDirection: 'column',
            width: { xs: '100vw', md: DRAWER_WIDTH },
            maxWidth: '100vw',
            bgcolor: 'background.paper',
            boxShadow: (theme) => theme.palette.mb.drawerShadow,
            borderStartStartRadius: { md: '10px' },
            borderEndStartRadius: { md: '10px' },
          },
        }}>
        <Grid
          container
          alignItems="center"
          wrap="nowrap"
          gap={1.25}
          sx={{
            p: { xs: '16px 12px 12px', md: '20px 24px 16px' },
            borderBottom: '1px solid',
            borderColor: 'mb.lineSoft',
            flexShrink: 0,
          }}>
          <IconButton onClick={handleClose} aria-label="close" sx={{ width: 44, height: 44, color: 'text.primary' }}>
            <CloseIcon />
          </IconButton>
          <Typography variant="h4" component="div" noWrap sx={{ flex: 1, minWidth: 0 }}>
            {title}
          </Typography>
          {titleChip}
          {openAll && (
            <Button variant="outlined" color="inherit" size="small" onClick={openAll} sx={{ flexShrink: 0 }}>
              {t('calendar.edit_order.openAll')}
            </Button>
          )}
        </Grid>
        <Grid container flexDirection="column" flexWrap="nowrap" overflow="hidden" flex={1} minHeight={0} width="100%">
          {children}
        </Grid>
      </Drawer>
    </div>
  );
}
